const fr = {
  editAbout: "Edit About ({{lang}})",
  about: "Edit About - {{lang}}",
  files: "Files",
  delete: "Delete",
  downloadFile: "Download File",
  copyImageToClipboard: "Copy file <img> tag to clipboard",
  copyFileToClipboard: "Copy file link to clipboard",
  addNewFile: "Add new file",
  save: "Save",
  cancel: "Cancel",
  all: "Tous",
// imported from LIComp-UI
  header: {
    title: "Instruments juridiques de l’OCDE",
    login: "Connexion",
    logout: "Déconnexion",
    searchPlaceholder: "rechercher...",
    menu: {
      home: "Accueil",
      generalInformation: "À propos",
      fullList: "Liste complète",
      advancedSearch: "Recherche avancée",
      notPublished: "Créer/Publier",
      adherences: "Adhésions",
      statistics: "Chiffres clés"
    }
  },
  footer: {
    credits: "© OCDE 2017 - Instruments juridiques de l’OCDE"
  },
  home: {
    searchTitle: "Recherche rapide",
    searchHint: "Titre ou référence",
    recentDevelopmentsTitle: "Derniers développements",
    keyFiguresTitle: "Chiffres clés",
    searchButton: "Rechercher",
    promptSubscription: "Être informé(e) des derniers développements",
    subsSuccessMessage: "Vous êtes désormais inscrit aux notifications par email pour les futures mises à jour",
    unsubsSuccessMessage: "Vous êtes désinscrit et ne recevrez plus de notifications par email pour les futures mises à jour",
    subsErrorMessage: "Une erreur s’est produite, merci de bien vouloir réessayer",
    loginRequired: 'Merci de vous connecter pour l\'utilisation de cette fonction'
  },
  generalInformation: {
    title: "À propos",
    content: "Mercedem aut nummos unde unde extricat, amaras. Qui ipsorum lingua Celtae, nostra Galli appellantur. Petierunt uti sibi concilium totius Galliae in diem certam indicere. Quisque placerat facilisis egestas cillum dolore."
  },
  stats: {
    mainTitle: "Statistiques",
    "instruments-by-type": "Instruments Juridiques par Type",
    "in-force-by-year": "Instruments Juridiques en Vigueur",
    "non-member-adherences-by-year": "Nombre d'Adhésions de non-Membres aux Instruments Juridiques de l'OCDE",
    adherencesByYear: "Adhésions par an",
    "key-partner-adherences": "Adhésions des Partenaires Clés",
    "accession-countries-adherences": "Adhésions des Pays Candidats à l'Adhésion",
    "country-programmes-adherences": "Adhésions des Programmes par Pays",
    loading: "Chargement de graphique"
  },
  adherences: {
    title: "Liste des adhérences",
    loading: "Chargement des adhérences...",
    adherence: "Adhésion",
    oecdMembers: "Membres de l'OCDE",
    nonMembers: "Non-Membres",
    documents: "Documents",
    others: 'Autre',
    close: "Fermer",
    viewOther: "Autres adhérences",
    resultCount: "Nombre d'adhérences :",
  },
  misc: {
    currentLanguage: "Français",
    start: "Début",
    end: "Fin",
    search: "Rechercher",
    date: "Date",
    country: "Adhérent",
    status: "Statut",
    type: "Type",
    references: "References",
    filter: "Filtrer",
    clearFilter: "Réinitialiser",
    AdherentMandatory: "* Un adhérent au moins doit être sélectionné pour lancer la recherche",
    loading: "Chargement...",
    none: 'Aucun',
    downloadInstrumentButton: "Télécharger/imprimer la brochure",
    downloadInstrumentTooltip: "Download or print the booklet of this legal instrument (PDF file)",
    noResults: "Aucun résultat...",
    shareLinkButton: "Partager le lien",
    shareLinkTooltip: "Partager lien",
    shareSelectionLink: "Partager un lien vers cette sélection",
    edit: "Éditer"
  },
  dates: {
    documentReferences: "Cote",
    minutesDocReferences: "Minutes cote",
  },
  instruments: {
    normalTitle: "Liste complète des instruments juridiques",
    createNewInstrument: "Créer un nouvel instrument",
    id: "Identifiant",
    instrumentId: "Identifiant de l'instrument",
    name: "Titre",
    status: "Statut",
    dateOfPublish: "Date de publication",
    dateOfAdoption: "Date d'adoption",
    dateOfInForce: "Date d'entrée en force",
    dateOfAbrogation: "Date d'abrogation",
    dateOfLastAmendment: "Date de la dernière modification",
    instrument: "Instrument",
    loading: "Chargement des instruments...",
    resultCount: "Nombre d'instruments juridiques :",
    reference: "Référence",
    buttons: {
      preview: "Aperçu",
      open: "Ouvrir",
      edit: "Éditer"
    }
  },

  instrument: {
    titles: {
      mainText: "Texte",
      committees: "Comité(s)",
      dates: "Date(s)/Référence(s)",
      backgroundInformation: "Informations générales",
      relatedInstruments: "Instrument(s) associé(s)",
      supportDocuments: "Document(s) associé(s)",
      adherents: "Adhérents",
      adoptedOn: "Adopté le",
      dateOfInForce: "Date d'entrée en force",
      dateOfAbrogation: "Date d'abrogation",
      lastAmendmentOn: "Modifié le",
      monitoring: "Mise en œuvre",
      legInternalNotes: "Notes internes LEG",
      involvedCommittees: "Comités impliqués",
      parentCommittees: "Comités parents",
      thereIsErrors: "L'instrument n'a pas pu être sauvegardé pour les raisons suivantes :",
      draftText: "ÉBAUCHE",
      publishedReport: 'Version publiée',
      translations: 'Translations',
      unofficialTranslations: 'Traductions non officielles',
      hostedDocuments: 'Hosted documents',
    }
  },
  filters: {
    types: "Type(s)",
    committees: "Comité(s)",
    adherents: "Adhérents",
    themes: "Thème(s)",
    status: "Statut",
    yearOfAdoption: "Année d'adoption",
    yearOfInForce: "Année d'entrée en vigueur",
    yearOfAbrogation: "Année d'abrogation",
    yearOfLastAmendment: "Année du dernier amendement",
    referenceId: "Référence",
    monitoring: "Clause de suivi",
    monitoringYear: "Année du rapport de suivi",
    asNeeded: "Comme requis",
    everyXYears: "Tous les X ans",
    withinXYearsThenAsNeeded: "Dans les X ans puis comme requis",
    freeTextSearch: "Recherche plein texte",
    freeTextSearchPlaceholder: "Rechercher...",
    searchScope: "Périmètre de la recherche",
    inAllText: "Dans tout le texte",
    inTitles: "Dans les titres",
    searchType: "Type de recherche",
    exactPhrase: "Phrase exacte",
    withAllWords: "Avec tous les mots",
    publishStatus: "Statut de publication",
    notPublished: "Non publié",
    published: "Publié",
    publishDate: "Date de publication",
    startDate: "De",
    endDate: "À",
    filter: "Filtre",
    dateFilters: "Date",
    searchPlaceholder: "Identifiant de l'instrument ou référence ONE",
    includeNotInForce: "Inclure les instruments juridiques non entrés en vigueur",
    yearInvalid: "L'année doit être entre 1952 et {max}",
    searchError: 'Impossible de lancer la recherche',
    activatedTitle: 'Filtres activés',
    keywords: 'Mots-clés'
  },
  printout: {
    title: 'Liste d’instruments juridiques de l’OCDE',
    disclaimer: '<p>Cette liste a été créée à partir du Recueil des instruments juridiques de l’OCDE et comprend une sélection d’instruments juridiques.</p> <p>Pour accéder aux informations officielles et à jour, notamment le texte intégral des instruments juridiques sélectionnés, veuillez consulter le Recueil des instruments juridiques de l’OCDE : <a href="http://legalinstruments.oecd.org">http://legalinstruments.oecd.org</a></p>',
    downloadPrintListButton: 'Télécharger/Imprimer la liste',
    shareListButton: 'Partager la liste',
    printSelection: "Imprimer la sélection",
    printSelectionWithMainText: "Télécharger la sélection en un seul document PDF",
    printSelectionWithMainTextAndMetaData: "Imprimer la sélection avec le texte principal et les meta-données",
    printSingleWithMainText: "Imprimer l'instrument avec le texte principal",
    printSingleWithMainTextAndMetaData: "Imprimer l'instrument avec le texte principal et les meta-données",
    shareListByMailRecipients: 'Email recipients:',
    shareListByMailViaBackendSuccess: 'E-mail message has been sent successfully',
    shareListByMailViaBackendError: 'Oops, something went wrong: {{errorDescription}}',
    validation: {
      noRecipients: 'Missing or invalid recipients',
      emailValidationFailed: 'Failed to validate some of recipient emails.',
      emailsExcluded: 'Emails excluded: {{mails}}',
      emailsIncluded: 'Mail will be sent to: {{mails}}'
    }
  },
  monitoring: {
    clause: "Clause",
    year: "Année",
    documentReferences: "Référence(s) de document(s)"
  },
  mainText: {
    loading: "Chargement..."
  },
  pdf: {
    page: "Page: ",
    download: "Télécharger"
  },
  relatedInstruments: {
    replacedBy: "Remplacé par",
    replaces: "Remplace",
    relatedTo: "Relié à"
  },
  error404: {
    title: "404 Page non trouvée"
  },

  error403: {
    title: "403 Vous n'êtes pas autorisé"
  },
  id: 'Id',
  admin: 'Admin',
  addNewLine: 'Add new line',
  englishName: 'English Text',
  frenchName: 'French Text',
  englishSortOrder: 'English Sort Order',
  frenchSortOrder: 'French Sort Order',
  enabled: 'Enabled',
  type: 'Type',
  accessionDate: 'Accession date',
  accessionCountry: 'Acession country',
  keyPartner: 'Key partner',
  hasCountryProgramme: 'Has country programme',
  deleteTitle: 'Delete',
  ok: 'ok',
  adminCancelText: 'If you have made changes, they will not be saved.',
  areYouSure: 'Are you sure?',
  cancelUpdates: 'Cancel Updates',
  adminNoteText: "NOTE: For external lists like countries and committees, please enter an id greater than 100,000 for new entities that must not be synchronized with OECD's source databases. In any case, the synchronization would only affect the names of the list items. Any other properties are not touched during syncronization.",
  aboutSaved: "About Saved",
  listsUpdatedSuccessfully: "Lists updated successfully",
  error: "Error",
  Data: "Données",
  News: "Actualités",
  Publications: "Publications",
  'Job vacancies': "Emplois",
  'OECD Legal Instruments': "Instruments juridiques de l’OCDE",
  'More sites': "Plus de sites",
  'OECD Better Life Index': "OECD Better Life Index",
  'OECD iLibrary': "OECD iLibrary",
  'OECD Observer': "L’Observateur de l’OCDE",
  'OECD Insights blog': "OECD Insights blog",
  'OECD Development Centre': "Centre de développement de l’OCDE",
  'NEA Nuclear Energy Agency': "AEN - Agence pour l'énergie nucléaire",
  'IEA International Energy Agency': "AIE - Agence internationale de l'énergie",
  'SWAC Sahel and West Africa Club': "CSAO - Club du Sahel et de l'Afrique de l'Ouest",
  'FATF Financial Action Task Force': "GAFI - Groupe d'action financière",
  'ITF International Transport Forum': "ITF - Forum international des transports",
  Adherents: "Adhérents",
  "createpublish": "Créer/Publier",
  subsSuccessMessage: "Vous êtes désormais inscrit aux notifications par email pour les futures mises à jour",
  unsubsSuccessMessage: "Vous êtes désinscrit et ne recevrez plus de notifications par email pour les futures mises à jour",
  subsErrorMessage: "Une erreur s’est produite, merci de bien vouloir réessayer",
  loginRequired: 'Merci de vous connecter pour l\'utilisation de cette fonction',
  instrumentTypes: 'Type(s)',
  committees: 'Comité(s)',
  themes: 'Thème(s)',
  'COUNTRYTERRITORY': 'COUNTRY/TERRITOIRE',
  'STATUS': 'STATUT',
  'DATE': 'DATE',
  'COMMENTS EN': 'COMMENTAIRES EN',
  'COMMENTS FR': 'COMMENTAIRES FR',
  'DOCUMENTS': 'DOCUMENTS',
  'DELETE': 'SUPPRIMER',
  'OECD Members': 'Membres de l\'OCDE',
  'NonMembers': 'Non-Membres',
  'add new line': 'ajouter une nouvelle ligne',
  'OthersEU': 'Autres/UE',
  'URL or ONE Reference': 'URL ou référence ONE',
  'DescriptionEn': 'Description - En',
  'DescriptionFr': 'Description - Fr',
  'Cover Image': 'Image de couverture',
  'Photo creditsEn': 'Crédits credits - En',
  'Photo creditsFr': 'Crédits credits- Fr',
  'There is no cover image at the moment. You can upload one by clicking on the edit icon below.': 'Il n\'y a pas d\'image de couverture pour le moment. Vous pouvez en télécharger une en cliquant sur l\'icône d\'édition ci-dessous.',
  'Public View HTML or PDF': 'Vue publique (HTML or PDF)',
  'Booklet Word or PDF': 'Brochure (Word or PDF)',
  'Edit Public Text': 'Modifier le texte public',
  'English introduction': 'Introduction en anglais',
  'French introduction': 'Introduction en français',
  'Add new support document': 'Ajouter un nouveau document de support',
  'Clear': 'Réinitialiser',
  'Filter': 'Filtrer',
  'Year of adoption': 'Année d\'adoption',
  'Unpublish': 'Un-publish',
  search: "Rechercher",
  "Share List": "Partager la liste",
  "Email recipients": "Email recipients:",
  emailValidationFailed: 'Failed to validate some of recipient emails.',
  emailsExcluded: 'Emails excluded: {{mails}}',
  emailsIncluded: 'Mail will be sent to: {{mails}}',
  printDisclaimer: '<p>Cette liste a été créée à partir du Recueil des instruments juridiques de l’OCDE et comprend une sélection d’instruments juridiques.</p> <p>Pour accéder aux informations officielles et à jour, notamment le texte intégral des instruments juridiques sélectionnés, veuillez consulter le Recueil des instruments juridiques de l’OCDE : <a href="http://legalinstruments.oecd.org">http://legalinstruments.oecd.org</a></p>',
  types: "Type(s)",
  adherenceCheckboxPrimaryText: "Inclure les instruments juridiques non entrés en vigueur",
  //adherenceCheckboxSecondaryText: "* Un adhérent au moins doit être sélectionné pour lancer la recherche",
  "Booklets deactivated": "Booklets deactivated",
  "Title or reference": "Titre ou référence",
  "upload": "Upload",
  "Recent Development": "Derniers développements",
  "Inform me about recent developments": "Être informé(e) des derniers développements",
  "Quick Search": "Recherche rapide",
  "from": "De",
  "to": "À",
  "Key Figures": "Chiffres clés",
  "Number of legal instruments": "Nombre d'instruments juridiques",
  downloadPrintListButton: 'Télécharger/Imprimer la liste',
  shareListButton: 'Partager la liste',
  "Fulltext search": "Recherche plein texte",
  "Search scope": "Périmètre de la recherche",
  "In all text": "Dans tout le texte",
  "In titles": "Dans les titres",
  "Create new instrument": "Créer un nouvel instrument",
  "Publish status": "Statut de publication",
  "Home": "Accueil",
  "About": "À propos",
  "Advanced search": "Recherche avancée",
  "Full list": "Liste complète",
  "Adherences": "Adhésions",
  "Key figures": "Chiffres clés",
  "Search": "Rechercher",
  "text": "Texte",
  "Background information": "Informations générales",
  "Related documents": "Document(s) associé(s)",
  "Unofficial translations": "Traductions non officielles",
  "DateReference": "Date(s)/Référence(s)",
  "Related instruments": "Instrument(s) associé(s)",
  "Implementation": "Mise en œuvre",
  "LEG internal notes": "Notes internes LEG",
  relatedTo: "Relié à",
  oecdMembers: "Membres de l'OCDE",
  nonMembers: "Non-Membres",
  disclaimer: "Le Recueil des instruments juridiques de l’OCDE comprend les textes de tous les instruments juridiques adoptés dans le cadre de l’Organisation de coopération et de développement économiques (OCDE) ainsi que des informations complémentaires, notamment la liste des Membres et non-Membres de l’OCDE y ayant adhéré (les Adhérents).",
  None: "Aucun",
  footerDisclaimer: 'Le présent Recueil des instruments juridiques de l’OCDE est la propriété de l’OCDE. Il représente un investissement important et ne peut être reproduit en totalité ou en partie sans l’autorisation expresse de l’OCDE.  Pour toute utilisation, reproduction et traduction des différents instruments juridiques, veuillez consulter les <a href="http://www.oecd.org/fr/conditionsdutilisation/"> conditions d’utilisation</a>.',
  "Recent developments": "Derniers Développements",
  status: "Statut",
  "DATE OF PUBLISH": "Date de publication",
  "DATE OF ADOPTION": "Date d'adoption",
  title: 'Titre',
  identifier: 'IDENTIFIANT',
  reference: "Référence",
  searchPlaceholder: "Identifiant de l'instrument ou référence ONE",
  "Number of adherences": "Nombre d'adhérences",
  adhId: 'IDENTIFIANT DE L\'INSTRUMENT',
  "Adherences of Key Partners": "Adhésions des Partenaires Clés",
  "Adherences of Accession Countries": "Adhésions des Pays Candidats à l'Adhésion",
  "Adherences of Country-Programme Countries": "Adhésions des Programmes par Pays",
  "Legal instruments by type": "Instruments Juridiques par Type",
  "Legal Instruments in Force": "Instruments Juridiques en Vigueur",
  "non-member-adherences-by-year": "Nombre d'Adhésions de non-Membres aux Instruments Juridiques de l'OCDE",
  "Not published": "Non publié",
  "Published": "Publié",
  activatedFilter: "Filtres activés",
  adherenceDate: "Date d'adhérence",
  "Adopted on": "Adopté le",
  "Amended on": "Modifié le",
  backgroundInformation: "Informations générales",
  datesReferences: "Date(s)/Référence(s)",
  activatedTitle: 'Filtres activés',
  "Share via Email": "Partager par mail",
};

export default fr;
